module.exports = __webpack_public_path__ + "img/img24.f71c6031.svg";